/*
 * @Author       : panyangyang
 * @Date         : 2026-08-28 15:31:31
 * @LastEditTime : 2026-09-03 09:28:12
 * @LastEditors  : panyangyang
 * @Description  :
 * @FilePath     : \ngs_platform_manage_admin\src\api\modules\large-screen.js
 */

import request from '../request.js'

// 获取大屏数据 --- 叶凡
export const getScreenInfo = function(data) {
	return request({
		url: '/yyScreen/getScreenInfo',
		method: 'post',
		data
	})
}

// 前十代理机构/招标人切换 --- 叶凡
export const getTopCompany = function(data) {
	return request({
		url: '/yyScreen/getTopCompany',
		method: 'post',
		data
	})
}
